import React from "react";
import "./index.css"
import {
    Typography,
    Button,
    DatePicker,
    Layout
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import btn_close from '../../assets/images/btn_close.png';
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import Carousel from 'react-multi-carousel';
import useWindowDimensions from "../../components/useWindowDemision";
import image_search from '../../assets/images/image_search.png';
import 'react-multi-carousel/lib/styles.css';

const { Paragraph } = Typography;

const ViewLogHistory = ({
    dateFrom,
    dataHistory,
    dataImgHistory,
    deleteHistory,
    showDetailPrdHistory,
    setIsLogHistory,
    onChangeDateFrom,
    onChangeDateTo,
    dateNow,
    searChLogHistory

}) => {

    const { Header, Content } = Layout;
    const { width } = useWindowDimensions();

    const styleListProduct = {
        display: 'flex',
        height: 135,
        backgroundColor: '#FFFFFF',
        borderRadius: 5,
        margin: 5,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 20,
        marginBottom: 20,
        marginTop: 0
    }
    const styleImgDelete = {
        width: 22,
        height: 22,
        borderRadius: 11,
        backgroundColor: '#CCCCCC',
        marginBottom: 1,
        marginRight: -6,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
    const textInItemChild = {
        margin: 10,
        alignItems: 'center',
        display: 'flex',
        width: 80,
    }
    const styleHeader = {
        display: 'flex',
        backgroundColor: 'transparent',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    }
    const styleTitleTop = {
        display: 'flex',
        height: 50, width: '100%',
        justifyContent: 'center',
    }
    const styleBody = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    }
    const styleBodyDate={
        // marginTop: 20,
        flexDirection: 'column',
        display: 'flex',
        width: '100%',
        marginLeft: 10,
        marginRight: 10,
        alignItems: 'center',
        justifyContent: 'center'
    }
    const styleInputDate ={
        flexDirection: 'row', 
        display: 'flex'
    }
    const bodyContent={
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        overflowY: 'scroll'
    }
    const styleInput={
        flexDirection: 'column',
        display: 'flex', 
        marginTop: 10, 
        alignItems: 'flex-end' 
    }
    const dataBody ={
        flexDirection:'row', 
        display: 'flex', 
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 15
    }
    const itemNotSearchs={
        display: 'flex',
        width:width, 
        height:'100%', 
        backgroundColor:'#F1F1F1',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        paddingBottom:40
    }
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 375 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 375, min: 0 },
            items: 3
        },
    };

    const dataChildHistory = (itemChild, index) => {

        const itemChildProductLog = (itemPrd, index3) => {
            // if(!itemPrd.packing_spec) return;
            return (
                <div key={index3.toString()} style={styleListProduct}>
                    <div
                        onClick={() => deleteHistory(itemPrd)}
                        style={{
                            ...styleImgDelete,
                            position: 'absolute',
                            top: 0, right: 9,
                        }}>
                        <img src={btn_close} width="50%" height="50%" alt="imageBtnDelete" />
                    </div>

                    <div onClick={() => showDetailPrdHistory(itemPrd, index3)} style={styleBody}>
                        <div style={{ width: 80, height: 80, padding: 5 }}>
                            <img
                                alt={index3.toString()}
                                style={{ marginTop: 10, height: '100%', width: '100%' }}
                                src={
                                    dataImgHistory.filter((item_url) => item_url.item_code === itemPrd.item_code)[0] ?
                                        dataImgHistory.filter((item_url) => item_url.item_code === itemPrd.item_code)[0]?.image_url
                                        : 'https://usmh-image.com/stage-thumbnail/item/100/79/4904210460479.jpg'
                                }
                            />
                        </div>

                        <div style={textInItemChild}>
                            <Paragraph
                                className="text_item_category"
                                ellipsis={true}>
                                {itemPrd.food_name ? itemPrd.food_name : ''}
                            </Paragraph>

                        </div>

                        <div
                            className="packing-spec-search"
                            style={{ backgroundColor: '#09D3B7', position: 'fixed', bottom: 10 }}>
                            <Paragraph
                                className="text-packing-search"
                                ellipsis={true}>
                                {Math.round((itemPrd.packing_show * 100) * 100) / 100 + "グラム"}
                            </Paragraph>
                        </div>
                    </div>
                </div>
            );
        };

        return (
            <div key={index.toString()} style={{ width: '100%' }}>
                <h6
                    style={{ marginTop: 10 }}
                    className="text-category-list-hr">

                    {itemChild.date ? itemChild.date : ''}
                </h6>
                <Carousel
                    responsive={responsive}
                >
                    {itemChild.child.length ?
                        itemChild.child.map((itemPrd, index3) => itemChildProductLog(itemPrd, index3)) : null}
                </Carousel>
            </div>
        )
    };

    const bodyNotSearched =()=>{
        return(
            <div style={itemNotSearchs}>
                <div style={{ width:145, height:145}}>
                    <img src={image_search} width="100%" height="100%" alt="imageSearch"/>
                </div>
                <Paragraph 
                    className="text-not-search" 
                    ellipsis={true}> 一致する検索結果がありません。</Paragraph>
            </div>
        );
    }

    return (

        <>
            <Header style={{ ...styleHeader, height: '25%' }}>
                <div style={{ ...styleTitleTop, position: "absolute", top: 10 }}>
                    <h6 className="text-title-top"> 登録履歴 </h6>
                </div>
                <div onClick={() => setIsLogHistory(false)}>
                    <ArrowLeftOutlined className="icon-goBack" />
                </div>

                <div style={dataBody}>
                    <div style={styleBodyDate}>
                        <div style={styleInputDate}>
                            <DatePicker
                                style={{ width: width * 2 / 3, maxWidth: 350 }}
                                onChange={onChangeDateFrom}
                                value={moment(dateFrom, 'YYYY-MM-DD')}
                                allowClear={false}
                                inputReadOnly={true}
                            />
                            <h6 className="text-date-picker">から</h6>
                        </div>

                        <div style={styleInput}>
                            <div style={styleInputDate}>
                                <DatePicker
                                    style={{ width: width * 2 / 3, maxWidth: 350 }}
                                    onChange={onChangeDateTo}
                                    value={moment(dateNow, 'YYYY-MM-DD')}
                                    allowClear={false}
                                    inputReadOnly={true}
                                />
                                <h6 className="text-date-picker">まで</h6>
                            </div>
                        </div>
                    </div>
                    <Button
                        type="primary"
                        shape="circle"
                        style={{ marginTop: 5 }}
                        icon={<SearchOutlined />}
                        onClick={searChLogHistory}
                    />
                </div>
            </Header>

            <Content style={bodyContent}>
                {dataHistory?.length > 0 ?
                    dataHistory.map((item, index) => dataChildHistory(item, index)) : bodyNotSearched()
                }
            </Content>
        </>
    )
}

export default ViewLogHistory
